import React from 'react';
import { formatTime } from 'utilities/calendarFunctions';

export interface TimeSlotButtonProps {
	dataType?: string;
	startTime: string | Date;
	endTime: string | Date;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	label: string;
	style?: React.CSSProperties;
	className?: string;
}

const TimeSlotButton: React.FC<TimeSlotButtonProps> = ({
	dataType,
	startTime,
	endTime,
	onClick,
	label,
	style,
	className = '',
}) => {
	const meta = label === 'BLK' ? <b>{label}</b> : label;
	const timespan = formatTime(startTime) + '-' + formatTime(endTime);

	return (
		<button
			className={`time-slot-button ${dataType ? dataType + '-button' : ''} ${className}`}
			title={timespan + ' - ' + label}
			onClick={onClick}
			style={style}
		>
			<strong className="time-span">{timespan}</strong>
			<span className="slot-metadata">{meta}</span>
		</button>
	);
};

export default TimeSlotButton;